import React, { useEffect, useState } from 'react';
import { api } from '../context/AuthContext';

function Spark({ points, color, label, fmt }) {
  if (!points || points.length < 2) {
    return <div style={{ fontSize: 12, color: '#94a3b8', padding: '8px 0' }}>{label}: not enough history yet</div>;
  }
  const ys = points.map((p) => p.v);
  const min = Math.min(...ys);
  const max = Math.max(...ys);
  const span = max - min || 1;
  const W = 600;
  const H = 60;
  const d = points.map((p, i) => {
    const x = (i / (points.length - 1)) * W;
    const y = H - ((p.v - min) / span) * (H - 8) - 4;
    return (i ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
  }).join(' ');
  const first = points[0];
  const last = points[points.length - 1];
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#64748b', marginBottom: 2 }}>
        <span>{label}</span>
        <span>{fmt(first.v)} → <b style={{ color }}>{fmt(last.v)}</b> (min {fmt(min)} · max {fmt(max)})</span>
      </div>
      <svg viewBox={'0 0 ' + W + ' ' + H} preserveAspectRatio="none" style={{ width: '100%', height: 60, display: 'block' }}>
        <path d={d} fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke" />
      </svg>
    </div>
  );
}

export default function AseMonconfigTrend({ connectionId, names, refreshKey }) {
  const [name, setName] = useState('permission cache entries');
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    if (!connectionId || !name) return undefined;
    setData(null);
    setErr('');
    api.get('/api/sap/basis/ase-monconfig-history', { params: { connectionId, name, days } })
      .then((r) => { if (alive) setData(r.data); })
      .catch((e) => { if (alive) setErr((e && e.response && e.response.data && e.response.data.error) || String(e.message || e)); });
    return () => { alive = false; };
  }, [connectionId, name, days, refreshKey]);

  const rows = (data && data.rows) || [];
  const opts = (names && names.length ? names : (data && data.names) || []);
  const num = (v) => Number(v || 0).toLocaleString('en-US');
  const sel = { padding: '5px 8px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 12.5, background: 'transparent', color: 'inherit' };

  return (
    <div style={{ marginTop: 18, borderTop: '1px solid #e2e8f0', paddingTop: 14 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
        <span style={{ fontSize: 12.5, fontWeight: 600 }}>Trend</span>
        <select style={sel} value={name} onChange={(e) => setName(e.target.value)}>
          {opts.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
        <select style={sel} value={days} onChange={(e) => setDays(Number(e.target.value))}>
          {[7, 30, 90, 365].map((d) => <option key={d} value={d}>{d} days</option>)}
        </select>
        <span style={{ fontSize: 12, color: '#94a3b8' }}>
          {data ? (rows.length + ' snapshots of ' + (data.snapshots || 0) + ' recorded') : (err ? '' : 'loading...')}
        </span>
      </div>
      {err
        ? <div style={{ fontSize: 12.5, color: '#dc2626' }}>{err}</div>
        : (
          <>
            <Spark points={rows.map((r) => ({ v: Number(r.pct_act || 0) }))} color="#0891b2" label="% Active" fmt={(v) => v.toFixed(2) + '%'} />
            <Spark points={rows.map((r) => ({ v: Number(r.reuse_cnt || 0) }))} color="#dc2626" label="Reuse count (cumulative)" fmt={num} />
            <Spark points={rows.map((r) => ({ v: Number(r.max_used || 0) }))} color="#b45309" label="Max used" fmt={num} />
          </>
        )}
    </div>
  );
}
